import DecoMethodNameSelectFilter from "../../../shared/table/DecoMethodNameSelectFilter";
import DecoMethodHyphanateNameSelectFilter from "../../../shared/table/DecoMethodHyphanateNameSelectFilter";
import CategorySelectFilter from "../../../shared/table/CategorySelectFilter";

export const TABLE_COLUMNS = [
  {
    Header: "Category",
    accessor: "catName",
    Filter: CategorySelectFilter,
  },
  {
    Header: "Primary Deco Method",
    accessor: "primaryName",
    Filter: DecoMethodNameSelectFilter,
  },
  {
    Header: "Primary Hyphanate Name",
    accessor: "primaryHyphanateName",
    Filter: DecoMethodHyphanateNameSelectFilter,
  },
  {
    Header: "Secondary Deco Method",
    accessor: "secondaryName",
    Filter: DecoMethodNameSelectFilter,
  },
  {
    Header: "Secondary Hyphanate Name",
    accessor: "secondaryHyphanateName",
    Filter: DecoMethodHyphanateNameSelectFilter,
  },
  {
    Header: "Actions",
    id: "Actions",
  },
];
